module.exports = __webpack_public_path__ + "img/not-found.f6df12f8.svg";